export default __webpack_public_path__ + "static/media/empty.22cea256.png";